import React, { useState } from "react";
import { useNode, useEditor, UserComponent } from "@craftjs/core";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import ReactPlayer from "react-player/lazy";
import {
  BuilderBlock,
  defaultCssStyles,
  defaultStyleProps,
  IBuilderBlockProps,
} from "../../shared";
import { VideoSettings } from "./VideoSettings";
import { StyleSettings } from "@types";

export interface IVideoProps extends IBuilderBlockProps {
  videoUrl: string;
  videoFit: "cover" | "contain";
  videoPosition?:
    | "center top"
    | "center center"
    | "center bottom"
    | "left center"
    | "right center"
    | "left top"
    | "right top"
    | "left bottom"
    | "right bottom";
  loop: boolean;
  onEnded?: () => void;
}

export const Video: UserComponent<Partial<IVideoProps>> = ({
  videoUrl,
  width = "100%",
  height = "100%",
  videoFit = "cover",
  videoPosition = "center center",
  loop,
  onEnded,
  ...rest
}) => {
  const {
    connectors: { connect },
    setProp,
  } = useNode();

  const { enabled } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  const [playing, setPlaying] = useState<boolean>(false);

  return (
    <BuilderBlock {...rest} width="100%" height="100%">
      <div
        ref={connect as any}
        css={[
          defaultCssStyles(rest),
          css`
            width: ${width ?? "100%"};
            height: ${height ?? "100%"};

            video {
              object-fit: ${videoFit};
              object-position: ${videoPosition};
            }
          `,
        ]}
      >
        <ReactPlayer
          muted //should be muted otherwise autoplay won't work
          url={videoUrl}
          playing={playing}
          width={width ?? "100%"}
          height={height ?? "100%"}
          loop={loop}
          onReady={() => {
            setPlaying(true);
          }}
          onEnded={() => {
            setPlaying(false);
            onEnded?.();
          }}
        />
      </div>
    </BuilderBlock>
  );
};

Video.craft = {
  displayName: "Video",
  props: {},
  related: {
    toolbar: VideoSettings,
    styles: StyleSettings,
  },
};

Video.defaultProps = {
  ...defaultStyleProps,
  width: "100%",
  height: "100%",
  videoFit: "cover",
  videoPosition: "center center",
};
